module.exports = __webpack_public_path__ + "img/catalina-becerra.519bd164.jpg";